// extracted by mini-css-extract-plugin
export var auto = "_49-1";
export var spinner = "_49-0";